import { IReference } from '../references/IReference';

export enum Datatype {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  /**
   * In realtà è comunque una stringa (ID) ma lo gestiamo come un tipo
   * a parte per poterlo distinguere e devitare che si possano fare
   * reference a campi di tipo file non espliciti.
   */
  File = 'file',
  Date = 'date',
  Array = 'array',
  Object = 'object',
  Empty = 'empty',
  /**
   * Tipo di dato che non viene mostrato all'utente, ma che può essere
   * utilizzato per gestire casi speciali. Per esempio, nei button, permette
   * di generare i riferimenti sibiligns (opzioni salvate) senza mostrare
   * il riferimento al bottone stesso (in sé privo di valore).
   */
  Hidden = 'hidden',
  Image = 'image',
}

export type PlainDatatype =
  | Datatype.String
  | Datatype.Number
  | Datatype.Boolean
  | Datatype.Date;

export const PlainDatatypes = [
  Datatype.Boolean,
  Datatype.String,
  Datatype.Number,
  Datatype.Date,
];

export interface EmptyFieldDatatype {
  type: Datatype.Empty;
  // Per la gestione dei tipi, altrimenti bisognerebbe
  // sempre controllare che il field non sia EmptyFieldDatatype
  options?: never;
}

/**
 * Tipo di dato che non viene mostrato all'utente, ma che può essere
 * utilizzato per gestire casi speciali. Per esempio, nei button, permette
 * di generare i riferimenti sibiligns (opzioni salvate) senza mostrare
 * il riferimento al bottone stesso (in sé privo di valore).
 */
export interface HiddenFieldDatatype {
  type: Datatype.Hidden;
  // Per la gestione dei tipi
  options?: never;
}

export interface FileFielDataType {
  type: Datatype.File;
  options?: IFieldDatatypeOption[];
}

export interface PlainFieldDatatype {
  type: PlainDatatype;
  options?: IFieldDatatypeOption[];
}

export interface ObjectsArrayFieldDatatype {
  type: Datatype.Array;
  itemsType: Datatype.Object;
  structure: IReference[];
}

export interface PlainArrayFieldDatatype {
  type: Datatype.Array;
  itemsType: PlainDatatype;
  options?: IFieldDatatypeOption[];
}

export interface IFieldDatatypeOption {
  /**
   * Supporta solo stringhe e numeri. Al momento gestiamo solo stringhe che
   * vengono dalle classificazioni
   */
  value: string | number;
  label: string;
}

export type FieldDatatype =
  | PlainFieldDatatype
  | PlainArrayFieldDatatype
  | ObjectsArrayFieldDatatype
  | FileFielDataType
  | EmptyFieldDatatype
  | HiddenFieldDatatype;

export function isSameFieldDatatype(
  field: FieldDatatype | undefined,
  other: FieldDatatype | undefined,
) {
  if (field == null && other == null) return true;
  if (field == null || other == null) return false;
  if (field.type !== other.type) return false;
  if (field.type === Datatype.Array && other.type === Datatype.Array) {
    if (field.itemsType !== other.itemsType) return false;
    // TODO Eventualmente controllare anche le opzioni
  }
  return true;
}

export function isObjectsArrayField(
  field?: FieldDatatype,
): field is ObjectsArrayFieldDatatype {
  return (
    field != null &&
    field.type === Datatype.Array &&
    field.itemsType === Datatype.Object
  );
}

export function isPlainArrayField(
  field?: FieldDatatype,
): field is PlainArrayFieldDatatype {
  return (
    field != null &&
    field.type === Datatype.Array &&
    field.itemsType !== Datatype.Object
  );
}

export function isFieldDatatypeEmpty(
  field: FieldDatatype | undefined,
): field is EmptyFieldDatatype {
  return field?.type === Datatype.Empty;
}

export function isFieldDatatypeHidden(field: FieldDatatype | undefined) {
  return field?.type === Datatype.Hidden;
}
